<!--child.vue-->
<template>
  <div class="tips_wrap">
    <el-dialog
      title="房间信息"
      :visible.sync="dialogFormVisible"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form

        v-loading="loading"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="top"
        label-width="300px"
        class="demo-ruleForm"
      >
        <el-form-item label="房间名称" prop="name">
          <el-input   type="textarea" v-model="ruleForm.homeName"></el-input>
        </el-form-item>

        <el-form-item label="房间号" prop="name">
          <el-input   v-model="ruleForm.homeNum"></el-input>
        </el-form-item>

        <el-form-item label="房间类别" prop="region">
          <el-select
            style="width: 200px; margin-right: 20px"
            v-model="ruleForm.homeTypeId"
            placeholder="请选择"
            @change="productTypeChange"
          >
            <el-option
              v-for="item in options1"
              :key="item.id"
              :label="item.homeTypeName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="房间大小" prop="name">
          <el-select
            style="width: 200px; margin-right: 20px"
            v-model="ruleForm.homeSpace"
            placeholder="请选择"
            @change="productTypeChange"
          >
            <el-option
              v-for="item in space"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="床位" prop="name">
          <el-select
            style="width: 200px; margin-right: 20px"
            v-model="ruleForm.homeBed"
            placeholder="请选择"
            @change="productTypeChange"
          >
            <el-option
              v-for="item in bed"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否可吸烟" prop="name">
          <el-select
            style="width: 200px; margin-right: 20px"
            v-model="ruleForm.homeSm"
            placeholder="请选择"
            @change="productTypeChange"
          >
            <el-option
              v-for="item in smoke"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否有窗" prop="name">
          <el-select
            style="width: 200px; margin-right: 20px"
            v-model="ruleForm.homeWin"
            placeholder="请选择"
            @change="productTypeChange"
          >
            <el-option
              v-for="item in win"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="退房时间" prop="name">
          <el-time-select
            style="width: 200px; margin-right: 20px"
            v-model="ruleForm.homeQuit"
            :picker-options="{
              start: '08:30',
              step: '00:15',
              end: '18:30',
            }"
            placeholder="选择时间"
          >
          </el-time-select>
        </el-form-item>

        <el-form-item label="房间价格" prop="name">
          <el-input
            style="width: 200px; margin-right: 20px"
            v-model="ruleForm.homePrice"
          ></el-input>
        </el-form-item>

        <el-form-item label="主页展示标签" prop="region" v-if="false">
          <el-select
            multiple
            multiple-limit="4"
            style="width: 90%; margin-right: 20px"
            v-model="ruleForm.homeTagIds"
            placeholder="请输入"
            @change="productTypeChange"
          >
            <el-option
              v-for="item in tagList"
              :key="item.id"
              :label="item.homeTagName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-tooltip placement="top">
            <div slot="content">
              选择下面的详细的标签作为您的房间亮点给主页展示
              注:当前新建的标签无法选中,可在新增房间后退出重新编辑房间勾选
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="电脑配置" prop="delivery"      >
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="dn"
            style="width: 100%;"
            :fetch-suggestions="dnquerySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.label }}</span>
            </template>
          </el-autocomplete>
      
        </el-form-item>

        <el-form-item label="显示器配置" prop="delivery">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="xsq"
            style="width: 100%;"
            :fetch-suggestions="xsqquerySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.label }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="电竞设施" prop="delivery" width="100%">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="dj"
            style="width: 100%;"
            :fetch-suggestions="djquerySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.label }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="费用政策" prop="delivery">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="fy"
            style="width: 100%;"
            :fetch-suggestions="fyquerySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.label }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="便捷设施" prop="delivery">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="bj"
            style="width: 100%;"
            :fetch-suggestions="bjquerySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.label }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="洗浴配套" prop="delivery">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="xy"
            style="width: 100%;"
            :fetch-suggestions="xyquerySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.label }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="其他设施" prop="delivery">
          <el-autocomplete
            popper-class="my-autocomplete"
            v-model="qt"
            style="width: 100%;"
            :fetch-suggestions="qtquerySearch"
            placeholder="请输入内容"
            @select="handleSelect"
          >
            <i
              class="el-icon-edit el-input__icon"
              slot="suffix"
              @click="handleIconClick"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="name">{{ item.value }}</div>
              <span class="addr">{{ item.label }}</span>
            </template>
          </el-autocomplete>
        </el-form-item>

        <el-form-item label="注意事项" prop="name">
          <el-input
          type="textarea"
            style="width: 100%; margin-right: 20px"
            v-model="ruleForm.homeNotice"
          ></el-input>
        </el-form-item>

        <el-form-item label="房间图片" prop="desc">
          <el-upload
            class="upload-demo"
            action="/api2/minio/uploadFile"
            :headers="config"
            :on-preview="handlePreview"
            :on-success="fileSuccess"
            :on-remove="removeFile"
            :file-list="ruleForm.fileList"
            :before-upload="beforeAvatarUpload"
            list-type="picture-card"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb,第一张默认为房间主图
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <div style="display: flex">
            <div></div>
            <el-button type="primary" @click="submitForm()" style=""
              >保存</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("我是子组件");
  },

  data() {
    return {
      tagList: [],
      query: "",
      options: [], //标签筛选数据
      smoke: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      win: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      space: [
        {
          value: "1㎡-10㎡",
          label: "1㎡-10㎡",
        },
        {
          value: "10㎡-20㎡",
          label: "10㎡-20㎡",
        },
        {
          value: "20㎡-30㎡",
          label: "20㎡-30㎡",
        },
        {
          value: "30㎡-40㎡",
          label: "30㎡-40㎡",
        },
        {
          value: "50㎡-60㎡",
          label: "50㎡-60㎡",
        },
        {
          value: "60㎡+",
          label: "60㎡+",
        },
      ],
      bed: [
        {
          value: "1张",
          label: "1张",
        },
        {
          value: "2张",
          label: "2张",
        },
        {
          value: "3张",
          label: "3张",
        },
        {
          value: "4张",
          label: "4张",
        },
        {
          value: "5张",
          label: "5张",
        },
      ],
      loading2: false, //搜索加载
      tagData: [], //远程tag标签
      list: [], //原始标签数据
      tags: [],
      value: [],
      dn: "",
      xsq: "",
      dj: "",
      fy: "",
      bj: "",
      xy: "",
      qt: "",
      dns: [],
      xsqs: [],
      djs: [],
      fys: [],
      bjs: [],
      xys: [],
      qts: [],
      dynamicFormVisible: true,
      dynamicFormVisibleSur: true,
      token: "",
      loading: false,
      options1: [], //房间类别
      options2: [],

      dialogFormVisible: this.dialogShow,
      ruleForm: {
        sysUserId: "",
        id: "",
        homeSpace: "",
        homeBed: "",
        homeName: "",
        homePic: "",
        homeNum:"",
        homePrice: "",
        homeTypeId: "",
        homeTypeName: "",
        homeTagIds: [],
        fileList: [],
        tag: "",
        homeNotice: "",
        homeSm: "",
        homeWin: "",
      },
      rules: {},
    };
  },
  mounted() {
    this.token = window.sessionStorage.getItem("token");
  },
  computed: {
    config() {
      return { token: this.token };
    },
  },
  created() {
    this.ruleForm.sysUserId = this.$store.state.user.user.id;
    this.selectType();
    this.selectTag();
  },
  watch: {
    dialogShow(val) {
      this.dialogFormVisible = val;
    },
  },
  methods: {
    handleSelect(item) {
      console.log(item);
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    dnquerySearch(queryString, cb) {
      var data = this.dns;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
     xsqquerySearch(queryString, cb) {
      var data = this.xsqs;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    djquerySearch(queryString, cb) {
      var data = this.djs;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    fyquerySearch(queryString, cb) {
      var data = this.fys;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    bjquerySearch(queryString, cb) {
      var data = this.bjs;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    xyquerySearch(queryString, cb) {
      var data = this.xys;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    qtquerySearch(queryString, cb) {
      var data = this.qts;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    querySearch(queryString, cb) {
      var data = this.tagData;

      var results = queryString
        ? data.filter(this.createFilter(queryString))
        : data;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    




    createFilter(queryString) {
      return (data) => {
        return (
          data.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    focus(type) {
      this.query = type;
      console.log(type);
    },
    delResTag(data) {
      this.creardata();
      data.forEach((item) => {
        if (item.tagTypeName === "电脑配置") {
          this.dn = item.homeTagName;
        }
        if (item.tagTypeName === "显示器") {
          this.xsq = item.homeTagName;
        }
        if (item.tagTypeName === "电竞设施") {
          this.dj = item.homeTagName;
        }
        if (item.tagTypeName === "费用政策") {
          this.fy = item.homeTagName;
        }
        if (item.tagTypeName === "便捷设施") {
          this.bj = item.homeTagName;
        }
        if (item.tagTypeName === "洗浴配套") {
          this.xy = item.homeTagName;
        }
        if (item.tagTypeName === "其他设施") {
          this.qt = item.homeTagName;
        }
      });
    },
    remoteMethod(query) {
      console.log(this.tagData);
      if (query !== "") {
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;
          this.options = this.tagData.filter((item) => {
            return item.label.indexOf(query) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
      console.log(this.options);
    },
    delTag(arr, name) {
      console.log(name + "处理前数据：", arr);
      var newarr = [];
      console.log(this.options2)
      this.options2.forEach(function (e) {
        if (e.homeTagName == arr && e.tagTypeName == name) {
          var ob = {
            id: e.id,
            homeTagName: arr,
            tagTypeName: name,
          };

          newarr.push(ob);
          return newarr;
        }
        console.log(e.homeTagName);
      });
      if (newarr.length == 0) {
        var ob = {
          id: 1,
          homeTagName: arr,
          tagTypeName: name,
        };
        newarr.push(ob);
      }
      console.log(name + "处理后数据：", newarr);
      return newarr;
    },
    tag() {
      console.log("dn", this.dn);
      this.ruleForm.tag = "";

      if (this.dn) {
        this.dn = this.delTag(this.dn, "电脑配置");
      }
      if (this.xsq) {
        this.xsq = this.delTag(this.xsq, "显示器");
      }
      if (this.dj) {
        this.dj = this.delTag(this.dj, "电竞设施");
      }
      if (this.fy) {
        this.fy = this.delTag(this.fy, "费用政策");
      }
      if (this.bj) {
        this.bj = this.delTag(this.bj, "便捷设施");
      }
      if (this.xy) {
        this.xy = this.delTag(this.xy, "洗浴配套");
      }
      if (this.qt) {
        this.qt = this.delTag(this.qt, "其他设施");
      }
      console.log("dn", this.dn);
      console.log("xsq", this.xsq);
      const arr = [
        ...this.dn,
        ...this.xsq,
        ...this.dj,
        ...this.fy,
        ...this.bj,
        ...this.xy,
        ...this.qt,
      ];
      this.ruleForm.tag = JSON.stringify(arr);
      console.log("最终数组", arr);
    },
    creardata() {
      this.dn = "";
      this.xsq = "";
      this.dj = "";
      this.fy = "";
      this.bj = "";
      this.xy = "";
      this.qt = "";
      this.ruleForm.homeTagIds = [];
      this.ruleForm.tag = "";
    },
    selectTag() {
      var that = this;
      this.$axios
        .get("/api2/business/getAllTag/" + this.$store.state.user.user.id, {})
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.list = response.data.data;
            that.options2 = response.data.data;
            that.tagData = [];
            that.list.forEach((item) => {
              var ob = {
                value: `${item.homeTagName}`,
                label: `${item.tagTypeName}`,
                id: `${item.id}`,
              };
              if(item.tagTypeName=="电脑配置"){
                that.dns.push(ob);
              }
              if(item.tagTypeName=="显示器"){
                that.xsqs.push(ob);
              }
              if(item.tagTypeName=="电竞设施"){
                that.djs.push(ob);
              }
              if(item.tagTypeName=="费用政策"){
                that.fys.push(ob);
              }
              if(item.tagTypeName=="便捷设施"){
                that.bjs.push(ob);
              }
              if(item.tagTypeName=="洗浴配套"){
                that.xys.push(ob);
              }
              if(item.tagTypeName=="其他设施"){
                that.qts.push(ob);
              }
            });
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },
    removeFile(file, fileList) {
      this.ruleForm.fileList = fileList;
    },

    fileSuccess(response, file, fileList) {
      console.log(response);
      this.ruleForm.fileList.push({
        url: response.msg,
      });
      console.log(response);
      console.log(file);
      console.log(fileList);
    },
    toPeice() {
      return num.toLocaleString();
    },
    addInput() {
      this.ruleForm.sizePrices.push({
        sizeName: "",
        sizePrice: "",
        id: new Date().getTime(),
      });
    },
    delInput(id) {
      let myArray = this.ruleForm.sizePrices;
      myArray = myArray.filter(function (item) {
        return item.id !== id;
      });
      this.ruleForm.sizePrices = myArray;
    },
    saveForm() {},

    addInputSur() {
      this.ruleForm.surfacePrices.push({
        SurfaceName: "",
        SurfacePrice: "",
        id: new Date().getTime(),
      });
    },
    addInputSur2() {
      this.ruleForm.surfacePrices2.push({
        SurfaceName: "",
        SurfacePrice: "",
        id: new Date().getTime(),
      });
    },
    delInputSur2(id) {
      let myArray2 = this.ruleForm.surfacePrices2;
      myArray2 = myArray2.filter(function (item) {
        return item.id !== id;
      });
      this.ruleForm.surfacePrices2 = myArray2;
    },
    delInputSur(id) {
      let myArray = this.ruleForm.surfacePrices;
      myArray = myArray.filter(function (item) {
        return item.id !== id;
      });
      this.ruleForm.surfacePrices = myArray;
    },
    saveFormSur() {},
    submitForm() {
      this.tag();
      var that = this;

      this.$axios
        .post("/api2/business/addOrUpdateHome", that.ruleForm)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: "success",
              message: "操作成功",
            });
            that.ruleForm = {
              id: "",
              homeName: "",
              homePrice: 0,
              homeTypeId: "",
              homeTypeName: "",
              sysUserId: "",
              tag: [],
            };
            that.creardata();
            that.$emit("pushdata");
            that.$emit("productShowChange", false);
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },
    init(id) {
      var that = this;
      that.loading = true;
      this.$axios
        .get("/api2/business/getHomeInfo/" + id, {})
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.ruleForm = response.data.data;
            that.delResTag(response.data.data.tagList);
            that.tagList = response.data.data.tagList;
          } else {
            that.$message.error(response.data.mes);
          }
          that.loading = false;
        });
    },
    selectType() {
      var that = this;
      var req = {
        pageIndex: 0,
        pageCount: 100,
        query: {
          sysUserId: "1",
          id: "",
        },
      };
      req.sysUserId = this.$store.state.user.user.id;

      this.$axios
        .post("/api2/business/getHomeType", req)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.options1 = response.data.data;
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    add() {
      var that = this;
      that.req.id = "";
      that.tag();
      this.$axios
        .post("/api2/business/addOrUpdateHome", that.req)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: "success",
              message: "操作成功",
            });
            that.brandName = "";
            that.pushData();
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },
    brandChange(e) {
      console.log(e);

      this.options1.forEach((obj) => {
        if (obj.id === e) {
          this.ruleForm.homeTypeName = obj.homeTypeName;
        }
      });
    },
    productTypeChange(e) {
      this.options1.forEach((obj) => {
        if (obj.id === e) {
          this.ruleForm.homeTypeName = obj.homeTypeName;
        }
      });
    },
    closeDialog() {
      this.$emit("productShowChange", false);
    },
    updateBrand() {
      var that = this;
      this.$axios
        .post("/api2/business/addOrUpdateHome", that.req)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: "success",
              message: "操作成功",
            });
            that.pushData();
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },
  },
};
</script>
<style scoped>
.name{
  font-size: 17px;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}

</style>

